import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.some.js";
import { ElMessage, ElMessageBox } from 'element-plus';
import api from '@/api';
import LeftGroupList from '@/components/LeftGroupList';
import ButtonDialog from '@/components/ButtonDialog';
import TextLogicalReasoningQuestion from '@/components/subject/TextLogicalReasoning/TextLogicalReasoningQuestion.vue';
import TextAnalogyQuestionForm from '@/components/subject/TextLogicalReasoning/TextAnalogyQuestionForm.vue';
export default {
  name: 'TextLogicalReasoningQuestionView',
  components: {
    TextAnalogyQuestionForm,
    TextLogicalReasoningQuestion,
    LeftGroupList,
    ButtonDialog
  },
  data() {
    return {
      groups: [],
      groupId: null,
      questions: [],
      loading: false,
      total: 0,
      page: 0,
      currentPage: 1,
      pageSize: 20,
      filters: {
        contentMode: '',
        publishStatus: '',
        keyword: ''
      },
      drawerVisible: false,
      editingQuestion: null
    };
  },
  computed: {
    currentGroupName() {
      const group = this.groups.find(item => String(item.value) === String(this.groupId));
      return group?.text || group?.label || '';
    }
  },
  methods: {
    modeLabel(mode) {
      return mode === 'VERBAL_ANALOGY' ? '文字类比' : '图片题';
    },
    statusLabel(status) {
      return {
        DRAFT: '草稿',
        PUBLISHED: '已发布',
        ARCHIVED: '已归档'
      }[status] || '已发布';
    },
    statusTagType(status) {
      return {
        DRAFT: 'info',
        PUBLISHED: 'success',
        ARCHIVED: 'warning'
      }[status] || 'success';
    },
    canDelete(question) {
      return question.contentMode !== 'VERBAL_ANALOGY' || question.publishStatus === 'DRAFT';
    },
    createAnalogy() {
      this.editingQuestion = null;
      this.drawerVisible = true;
    },
    editAnalogy(question) {
      this.editingQuestion = question;
      this.drawerVisible = true;
    },
    async publish(question) {
      await ElMessageBox.confirm('发布后学生即可抽取此题，且题目不可直接修改。', '确认发布', {
        type: 'warning'
      });
      await api.publishTextAnalogy(question.id);
      ElMessage.success('题目已发布');
      this.fetchList();
    },
    async copyAsDraft(question) {
      const draft = await api.copyTextAnalogyAsDraft(question.id);
      ElMessage.success('已复制为新草稿');
      await this.fetchList();
      this.editAnalogy(draft);
    },
    async archive(question) {
      await ElMessageBox.confirm('归档后新考试不再抽取此题，历史复盘不受影响。', '确认归档', {
        type: 'warning'
      });
      await api.archiveTextAnalogy(question.id);
      ElMessage.success('题目已归档');
      this.fetchList();
    },
    async deleteQuestion(question) {
      await api.deleteTextLogicalQuestion(question.id);
      ElMessage.success('题目已删除');
      this.fetchList();
    },
    async deleteGroup() {
      await api.deleteTextLogicalGroup(this.groupId);
      ElMessage.success('分组已删除');
      this.initGroups();
    },
    onDraftSaved() {
      this.drawerVisible = false;
      this.fetchList();
    },
    onChoose(groupId) {
      this.groupId = groupId;
      this.resetAndFetch();
    },
    resetAndFetch() {
      this.page = 0;
      this.currentPage = 1;
      this.fetchList();
    },
    async fetchList(currentPage) {
      if (!this.groupId) {
        this.questions = [];
        this.total = 0;
        return;
      }
      if (typeof currentPage === 'number') this.page = currentPage - 1;
      this.loading = true;
      try {
        const result = await api.getTextLogicalQuestions({
          groupId: this.groupId,
          contentMode: this.filters.contentMode || undefined,
          publishStatus: this.filters.publishStatus || undefined,
          keyword: this.filters.keyword?.trim() || undefined,
          page: this.page,
          pageSize: this.pageSize
        });
        this.questions = result.list || [];
        this.total = result.total || 0;
      } finally {
        this.loading = false;
      }
    },
    async initGroups() {
      this.groups = await api.getTextLogicalGroups();
      if (!this.groups.some(item => String(item.value) === String(this.groupId))) {
        this.groupId = this.groups[0]?.value || null;
      }
      this.resetAndFetch();
    }
  },
  mounted() {
    this.initGroups();
  }
};